import React from "react";

class MessageForBlockedUsers extends React.Component {
    // constructor(props) {
    //     super(props);

    //     // this.handleLoad = this.handleLoad.bind(this)
    // }

    render() {
        //let warningIcon;
        if(this.props.blockedGroupEmployee)
        {
            return (
                <div className='warning-pg'>
                    Due to company separation process you are not allowed to create new Sites in ABB tenant. If you want to request for new SharePoint Site please contact with your IT Support team or create required resource directly in your organization provisioning tool.<br/>
                </div>
            );
        }
        else
        {
            return "";
        }
    }
}
export default MessageForBlockedUsers



// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/MessageForBlockedUsers.js